import type {CSSProperties} from 'react';
import {WEDGE_BRIEF_RECOVERY} from '@territory/tokens';

export type WedgeBv2ConfirmLook = 'bv2-confirm-location';

const BV2_CONFIRM_LOOKS = new Set<string>(['bv2-confirm-location']);
export const isWedgeBv2ConfirmLook = (look: string | undefined): look is WedgeBv2ConfirmLook => look !== undefined && BV2_CONFIRM_LOOKS.has(look);

/* Released brief v2 confirm action (prep-brief-v2, the account-not-confirmed notice). It is a 40px high block that does not stretch, with
   16px side padding, a 12px radius, no border, the fixed white recovery ink, 13.5px semibold type and the pointer cursor. The caller paints
   the red fill and the font face from the brief palette. It draws no transparent target and no anchor (wedgeBv2ConfirmDrawsHit): the button
   sits alone under its notice text, and an anchor would add a positioned box that legacy does not have. */
export const wedgeBv2ConfirmDrawsHit = (look: string): boolean => !isWedgeBv2ConfirmLook(look);

export function wedgeBv2ConfirmStyle(look: WedgeBv2ConfirmLook): CSSProperties {
  switch (look) {
    case 'bv2-confirm-location': return {
      alignSelf: 'flex-start', height: 40, padding: '0 16px', borderRadius: 12, border: 'none',
      color: WEDGE_BRIEF_RECOVERY.ink, fontSize: 13.5, fontWeight: 600, cursor: 'pointer',
    };
  }
}
